import { validarRecuperacao } from "./recuperacaoTotalizadores";
export function prepararPrevia(form, aposId = 0) {
  const p = {
    origem: form.origem,
    acao: form.acao,
    tpInsc: Number(form.tpInsc),
    nrInsc: form.nrInsc.replace(/\D/g, ""),
    cpf: form.cpf.replace(/\D/g, ""),
    competencia: form.competencia.trim(),
    tipos: form.tipos || (form.tipo ? [form.tipo] : []),
    repararInconsistentes: !!form.repararInconsistentes,
    aposId
  };
  if (
    p.tipos.some(
      (t) => !["S5001", "S5002", "S5003", "S5011", "S5012"].includes(t)
    )
  )
    throw new Error("Tipo não atendido. S-5013 não participa da recuperação.");
  if (p.origem === "GOVERNO_EMPREGADOR") {
    p.cpf = "";
    if (!p.tipos.length) p.tipos = ["S5011", "S5012"];
    if (p.tipos.some((t) => !["S5011", "S5012"].includes(t)))
      throw new Error("Consulte S-5011 e S-5012 por empregador e competência.");
  }
  if (p.cpf && !/^\d{11}$/.test(p.cpf))
    throw new Error("Informe um CPF com 11 dígitos.");
  if (p.competencia && !/^\d{4}(-(0[1-9]|1[0-2]))?$/.test(p.competencia))
    throw new Error("Use a competência no formato AAAA-MM ou AAAA.");
  if (["LOCAL", "GOVERNO_EMPREGADOR"].includes(p.origem) && !p.competencia)
    throw new Error("Informe a competência.");
  if (p.origem !== "LOCAL" && !/^\d{8,15}$/.test(p.nrInsc))
    throw new Error("Informe a inscrição do empregador.");
  if (p.origem === "GOVERNO") {
    if (p.tipos.some((t) => t.startsWith("S501")))
      throw new Error("Consulte o fechamento por empregador e competência.");
    const inicio = new Date(form.inicio),
      fim = new Date(form.fim);
    if (!p.cpf) throw new Error("Informe o CPF do trabalhador.");
    if (
      !form.inicio ||
      !form.fim ||
      !Number.isFinite(+inicio) ||
      !Number.isFinite(+fim) ||
      fim < inicio ||
      fim - inicio > 31 * 86400000
    )
      throw new Error("Informe um período de recepção válido de até 31 dias.");
    p.inicio = form.inicio.length === 16 ? form.inicio + ":00" : form.inicio;
    p.fim = form.fim.length === 16 ? form.fim + ":00" : form.fim;
  }
  if (p.origem === "MANUAL") {
    const v = validarRecuperacao(p, form.ids, form.recibos, form.mapa);
    if (v.id.length + v.nrRec.length > 500)
      throw new Error("Use até 500 identificadores por prévia.");
    if (v.id.some((id) => id.startsWith("ID013")))
      throw new Error("S-5013 não participa da recuperação.");
    p.ids = v.id;
    p.recibos = v.nrRec;
    p.recibosPorId = v.nrRecTotalizadorPorId || {};
  }
  return p;
}
const estados = {
  NAO_SELECIONADO: ["Não selecionado", "default"],
  DISPONIVEL: ["Disponível", "default"],
  PENDENTE: ["Aguardando recuperação", "default"],
  EM_EXECUCAO: ["Recuperando", "info"],
  AGUARDANDO_FOLHA: ["Aguardando a Folha", "warning"],
  APLICADO_FOLHA: ["Aplicado na Folha", "success"],
  CONSOLIDADO: ["Consolidado", "success"],
  JA_EXISTENTE: ["Conferido na Folha", "success"],
  FORA_FILTRO: ["Fora dos filtros", "default"],
  XML_INCOMPATIVEL: ["XML incompatível", "error"],
  BLOQUEADO: ["Requer revisão", "warning"],
  REVISAO_FOLHA: ["Revisar resultado da Folha", "warning"],
  FALHA: ["Falha na recuperação", "error"],
  FALHA_FOLHA: ["Falha na Folha", "error"]
};
export function estadoRecuperacao(estado) {
  const [texto, cor] = estados[estado] || [estado, "default"];
  return { texto, cor };
}
export function resumoRecuperacao(r) {
  const itens = r?.itens || [];
  return [
    { label: "Itens no recorte", valor: itens.length },
    {
      label: "XMLs guardados",
      valor: itens.filter((i) => i.arquivoGuardado).length
    },
    {
      label: "Confirmados na Folha",
      valor: itens.filter((i) =>
        ["APLICADO_FOLHA", "CONSOLIDADO", "JA_EXISTENTE"].includes(i.estado)
      ).length
    },
    {
      label: "Exigem atenção",
      valor: itens.filter((i) =>
        [
          "FALHA",
          "FALHA_FOLHA",
          "BLOQUEADO",
          "REVISAO_FOLHA",
          "XML_INCOMPATIVEL"
        ].includes(i.estado)
      ).length
    }
  ];
}

export function mensagemErroRecuperacao(erro, operacao = false) {
  if (!erro) return "";
  if (erro.status === 404)
    return operacao
      ? "Esta operação de recuperação não foi encontrada. Consulte o histórico ou crie uma nova prévia."
      : "A recuperação de totalizadores ainda não está disponível neste ambiente. Solicite ao suporte a atualização do serviço.";
  const mensagem = typeof erro === "string" ? erro : erro.message;
  if (mensagem === "Network Error")
    return "Não foi possível conectar ao serviço. Verifique a conexão e tente novamente.";
  if (!mensagem || /^Request failed with status code/.test(mensagem))
    return "Não foi possível concluir a consulta. Tente novamente; se o problema persistir, contate o suporte.";
  return mensagem;
}
